import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { RouteLocationNormalized } from "vue-router";
import { FilterType } from "@studyportals/omnisearch-interfaces";

/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	const keywordWhat = to.query?.[FilterType.KEYWORD_WHAT];
	const keywordWhere = to.query?.[FilterType.KEYWORD_WHERE];

	const keywordParts = [keywordWhat, keywordWhere].filter(Boolean);
	if(keywordParts.length === 0) return;

	const newKeyword = keywordParts.join(' ').trim();
	const filteredEntries = Object
		.entries(to.query)
		.filter(([key]) => key !== FilterType.KEYWORD_WHAT && key !== FilterType.KEYWORD_WHERE);

	to.query = {
		...Object.fromEntries(filteredEntries),
		[FilterType.KEYWORD]: newKeyword,
	};

	return navigateTo(to, { replace: true });
})
